import React, {useRef } from "react";
import { Helmet } from "react-helmet-async";
import "./TheSatimaWay.css";

// Background images
import newHeroImg from "../assets/satimaway-hero.jpeg"; // Hero image

import {
FaLaptopCode,
FaCode,
FaBullhorn,
FaSearch,
FaUsers,
FaChartLine
} from "react-icons/fa";

import { FaChevronDown } from "react-icons/fa";

const TheSatimaWay = () => {

  const servicesSliderRef = useRef(null);

  const scrollServices = (direction) => {
  
    if (servicesSliderRef.current) {
  
      const scrollAmount = servicesSliderRef.current.clientWidth;
  
  
      servicesSliderRef.current.scrollBy({
  
        left: direction === "next" ? scrollAmount : -scrollAmount,
  
        behavior: "smooth"
  
      });
  
    }
  
  };
  
  
    // ✅ FAQ toggle state
  
    const services = [
    {
      name: "Web Design",
      icon: <FaLaptopCode />,
      description:
        "Strategic websites designed to build trust, attract customers, and turn online visits into meaningful action.",
      link: "/web-design-kenya/"
    },
  
  
    {
      name: "Digital Marketing",
      icon: <FaBullhorn />,
      description:
        "Data-driven marketing strategies that increase visibility, attract qualified leads, and support sustainable sales.",
      link: "/digital-marketing-smes/"
    },
  
    {
      name: "Social Media Marketing",
      icon: <FaUsers />,
      description:
        "Strategic social media management that builds engagement, strengthens your brand, and creates opportunities for growth.",
      link: "/social-media-management-services/"
    },
  
  
    {
    name: "SEO Services",
    icon: <FaSearch />,
    description:
      "Strategic SEO that improves search visibility, attracts the right audience, and creates sustainable business growth.",
    link: "/seo-services-kenya/"
  },
  
    
    {
      name: "Digital Strategy",
      icon: <FaChartLine />,
      description:
        "Clear digital strategies that connect your goals, audience, and online channels into a focused growth plan.",
      link: "/digital-strategy-consultation/"
    },
  
    {
      name: "Custom Software",
      icon: <FaCode />,
      description:
        "Custom-built software that simplifies operations, automates processes, and helps your business work more efficiently.",
      link: "/custom-software-solutions/"
    }
  
  ];
  
  

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Strategy-First Digital Marketing in Kenya | Satima Technova Solutions
        </title>

        <link rel="canonical" href="https://satimatechnova.co.ke/the-satima-way/" />

        <meta
          name="description"
          content="Satima Technova Solutions delivers strategy-first digital marketing in Kenya, helping SMEs and professionals turn online visibility into leads, inquiries, and paying clients through measurable growth systems."
        />

        <meta
          name="keywords"
          content="digital marketing strategy Kenya, digital growth agency Kenya, strategy-first marketing Kenya, online growth partner Kenya, Satima Technova Solutions, Nairobi digital marketing"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Strategy-First Digital Marketing in Kenya | Satima Technova Solutions"
        />
        <meta
          property="og:description"
          content="Learn how Satima Technova Solutions helps Kenyan businesses turn online presence into paying clients with structured, results-driven digital marketing strategies."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://satimatechnova.co.ke/the-satima-way/"
        />
        

      {/* =========================================================
    THE SATIMA WAY — FAQ SCHEMA
========================================================= */}

<script
  type="application/ld+json"
  dangerouslySetInnerHTML={{
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is The Satima Way?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The Satima Way is Satima Technova Solutions' structured approach to digital growth. It combines clear strategy, the right digital systems, consistent execution, and continuous improvement to help businesses achieve meaningful online growth."
          }
        },
        {
          "@type": "Question",
          "name": "Why does Satima focus on strategy before digital marketing activities?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We believe businesses need direction before investing in disconnected digital activities. We first understand the business, audience, objectives, and challenges before recommending the appropriate digital marketing channels and solutions."
          }
        },
        {
          "@type": "Question",
          "name": "What does strategy-first digital marketing mean at Satima?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Strategy-first digital marketing means that websites, social media, SEO, advertising, content, and other digital activities are connected to a clear business objective rather than being treated as isolated activities."
          }
        },
        {
          "@type": "Question",
          "name": "What type of businesses does Satima work best with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Satima works best with SMEs, professionals, founders, and growing businesses in Kenya that value structure, clear communication, measurable progress, and long-term digital growth."
          }
        },
        {
          "@type": "Question",
          "name": "How does Satima measure digital marketing success?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We focus on meaningful business outcomes rather than vanity metrics alone. Depending on the strategy, this can include visibility, relevant traffic, enquiries, leads, conversions, customer engagement, and other measurable business objectives."
          }
        },
        {
          "@type": "Question",
          "name": "Why does Satima avoid disconnected digital marketing activities?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Disconnected activities can make it difficult to understand what is working and how different digital channels contribute to business growth. Satima focuses on creating connected digital systems where strategy, execution, measurement, and improvement work together."
          }
        }
      ]
    })
  }}
/>
      </Helmet>

      <main className="satima-way">
        

        {/* =========================================================
THE SATIMA WAY — PREMIUM HERO
========================================================= */}

<section
  className="strategy-hero-section"
  style={{
    backgroundImage: `url(${newHeroImg})`
  }}
>

  <div className="strategy-hero-overlay">

```
<div className="strategy-hero-wrapper">

  <div className="strategy-hero-content">

    {/* EYEBROW */}
    <span className="strategy-eyebrow">
      THE SATIMA WAY
    </span>

    {/* MAIN HEADING */}
    <h1>
      Digital Growth
      <br />
      With Direction.
    </h1>

    {/* SHORT MESSAGE */}
    <p className="strategy-hero-description">
      Strategy-led digital solutions designed to help your
      business grow with clarity, structure, and purpose.
    </p>

    {/* CTA */}
    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20understanding%20The%20Satima%20Way."
      target="_blank"
      rel="noopener noreferrer"
      className="strategy-hero-btn"
    >
      Start a Conversation
      <span>→</span>
    </a>

    {/* TRUST POINTS */}
    <div className="strategy-trust">

      <span>Business-first</span>

      <span>Strategy-led</span>

      <span>Growth-focused</span>

    </div>

  </div>

</div>
```

  </div>

</section>


        {/* =========================================================
    BRAND MEANING — THE SATIMA WAY
========================================================= */}

<section className="satima-brand-section">

  <div className="satima-brand-container">

    {/* SECTION INTRO */}

    <div className="satima-brand-header">

      <span className="satima-brand-label">
        WHAT WE STAND FOR
      </span>

      <h2>
        What Satima Stands For in
        <br />
        Kenyan Digital Growth
      </h2>

      <p>
        We believe meaningful digital growth starts with clarity,
        not more noise or disconnected marketing activities.
      </p>

    </div>


    {/* BRAND CARD */}

    <div className="satima-brand-card">

      <div className="satima-brand-accent"></div>


      <div className="satima-brand-content">

        <div className="satima-brand-statement">

          <span className="satima-brand-quote">
            “
          </span>

          <h3>
            Clarity. Strategy. Growth.
          </h3>

        </div>


        <div className="satima-brand-message">

          <p>
            Satima stands for
            <strong> clarity, strategy, and measurable growth.</strong>
          </p>


          <div className="satima-brand-principles">

            <div className="satima-brand-principle">

              <span className="satima-principle-number">
                01
              </span>

              <div>
                <h4>
                  Not Noise
                </h4>

                <p>
                  Your business doesn't need more digital activity
                  without a clear purpose.
                </p>
              </div>

            </div>


            <div className="satima-brand-principle">

              <span className="satima-principle-number">
                02
              </span>

              <div>
                <h4>
                  Not Hype
                </h4>

                <p>
                  We focus on practical strategies rather than
                  chasing every digital trend.
                </p>
              </div>

            </div>


            <div className="satima-brand-principle">

              <span className="satima-principle-number">
                03
              </span>

              <div>
                <h4>
                  Not Guesswork
                </h4>

                <p>
                  We make decisions around your business goals,
                  audience, data, and opportunities.
                </p>
              </div>

            </div>

          </div>


          <div className="satima-brand-highlight">

            <span className="satima-highlight-line"></span>

            <p>
              We believe businesses don't struggle online because
              they lack effort. They struggle because they lack
              direction.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

        {/* =========================================================
    POSITIONING SECTION
========================================================= */}

<section className="satima-positioning-section">

  <div className="satima-positioning-container">

    {/* SECTION HEADER */}

    <div className="satima-positioning-header">

      <span className="satima-positioning-label">
        OUR POSITIONING
      </span>

      <h2>
        A Digital Growth Partner
        <br />
        Built Around Business Results
      </h2>

    </div>


    {/* POSITIONING CONTENT */}

    <div className="satima-positioning-card">

      <div className="satima-positioning-accent"></div>


      <div className="satima-positioning-content">

        {/* MAIN STATEMENT */}

        <div className="satima-positioning-statement">

          <span className="satima-positioning-number">
            01
          </span>

          <h3>
            Strategy Before Activity.
            <br />
            Growth Before Vanity.
          </h3>

        </div>


        {/* DESCRIPTION */}

        <div className="satima-positioning-message">

          <p className="satima-positioning-highlight">
            Satima Technova Solutions is a strategy-first digital growth
            partner helping Kenyan businesses turn online visibility into
            real, paying clients.
          </p>


          <p>
            This belief shapes how we approach digital marketing, websites,
            SEO, social media, advertising, and technology. Instead of
            treating every service as a separate activity, we look at how
            each digital channel can contribute to the bigger business
            objective.
          </p>


          <div className="satima-positioning-line"></div>


          <p className="satima-positioning-closing">
            The goal is simple: <strong>create digital systems that make
            business growth more intentional, measurable, and sustainable.</strong>
          </p>

        </div>

      </div>

    </div>

  </div>

</section>

        {/* =========================================================
    BRAND PROMISE
========================================================= */}

<section className="satima-promise-section">

  <div className="satima-promise-container">

    {/* SECTION HEADER */}

    <div className="satima-promise-header">

      <span className="satima-promise-label">
        OUR PROMISE
      </span>

      <h2>
        Measurable Digital Marketing Growth in Kenya
      </h2>

      <p>
        We focus on digital solutions that contribute to meaningful
        business outcomes, not simply online activity.
      </p>

    </div>


    {/* PROMISE CARD */}

    <div className="satima-promise-card">

      <div className="satima-promise-accent"></div>


      <div className="satima-promise-content">

        <div className="satima-promise-statement">

          <span className="satima-promise-quote">
            “
          </span>

          <h3>
            Digital activity should have
            <span> a business purpose.</span>
          </h3>

        </div>


        <div className="satima-promise-message">

          <p>
            Every digital marketing solution we deliver is designed
            to produce <strong>measurable business results</strong>,
            not just activity.
          </p>


          {/* RESULTS */}

          <div className="satima-promise-results">

            <div className="satima-promise-result">

              <span className="satima-result-number">
                01
              </span>

              <div>
                <h4>Leads</h4>

                <p>
                  Create meaningful opportunities for your business.
                </p>
              </div>

            </div>


            <div className="satima-promise-result">

              <span className="satima-result-number">
                02
              </span>

              <div>
                <h4>Trust</h4>

                <p>
                  Build a stronger and more credible digital presence.
                </p>
              </div>

            </div>


            <div className="satima-promise-result">

              <span className="satima-result-number">
                03
              </span>

              <div>
                <h4>Conversions</h4>

                <p>
                  Turn attention and visibility into business opportunities.
                </p>

              </div>

            </div>

          </div>


          {/* FINAL STATEMENT */}

          <div className="satima-promise-highlight">

            <div className="satima-promise-highlight-line"></div>

            <p>
              If it doesn't contribute to growth, it doesn't belong
              in the Satima approach.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

        {/* =========================================================
    BRAND PILLARS
========================================================= */}

<section className="satima-pillars-section">

  <div className="satima-pillars-container">

    {/* SECTION HEADER */}

    <div className="satima-pillars-header">

      <span className="satima-pillars-label">
        WHAT WE ARE KNOWN FOR
      </span>

      <h2>
        A Different Approach to
        <br />
        Digital Growth
      </h2>

      <p>
        Our approach is built around principles that keep digital
        marketing connected to real business objectives.
      </p>

    </div>


    {/* PILLARS */}

    <div className="satima-pillars-grid">


      {/* PILLAR 01 */}

      <article className="satima-pillar-card">

        <span className="satima-pillar-number">
          01
        </span>

        <div className="satima-pillar-content">

          <h3>
            Strategy-First
            <br />
            Digital Marketing
          </h3>

          <p>
            We don't jump into posting, advertising, or building
            websites without first understanding the business,
            audience, and objective.
          </p>

        </div>

      </article>


      {/* PILLAR 02 */}

      <article className="satima-pillar-card">

        <span className="satima-pillar-number">
          02
        </span>

        <div className="satima-pillar-content">

          <h3>
            Business-Driven
            <br />
            Marketing Systems
          </h3>

          <p>
            Every message, platform, and conversion path is aligned
            with meaningful business outcomes rather than trends.
          </p>

        </div>

      </article>


      {/* PILLAR 03 */}

      <article className="satima-pillar-card">

        <span className="satima-pillar-number">
          03
        </span>

        <div className="satima-pillar-content">

          <h3>
            Results Over
            <br />
            Vanity Metrics
          </h3>

          <p>
            Likes don't pay bills. Followers don't guarantee growth.
            We focus on leads, enquiries, conversions, and genuine
            business opportunities.
          </p>

        </div>

      </article>


      {/* PILLAR 04 */}

      <article className="satima-pillar-card">

        <span className="satima-pillar-number">
          04
        </span>

        <div className="satima-pillar-content">

          <h3>
            Professional Digital
            <br />
            Growth Partnership
          </h3>

          <p>
            Clear communication, transparent pricing, structured
            delivery, and a professional approach built for
            long-term growth.
          </p>

        </div>

      </article>


    </div>


    {/* BOTTOM STATEMENT */}

    <div className="satima-pillars-bottom">

      <span className="satima-pillars-bottom-line"></span>

      <p>
        Strategy gives us direction. Systems create consistency.
        Results define success.
      </p>

    </div>

  </div>

</section>



        {/* =========================================================
    SATIMA VOICE & IDEAL CLIENT
========================================================= */}

<section className="satima-client-section">

  <div className="satima-client-container">


    {/* =====================================================
        SECTION HEADER
    ===================================================== */}

    <div className="satima-client-header">

      <span className="satima-client-label">
        HOW WE WORK
      </span>

      <h2>
        A Professional Approach to
        <br />
        Digital Growth
      </h2>

      <p>
        We approach every engagement with clarity, structure, and
        a genuine focus on helping businesses make better digital
        decisions.
      </p>

    </div>



    {/* =====================================================
        MAIN CONTENT
    ===================================================== */}

    <div className="satima-client-layout">


      {/* ===================================================
          LEFT — SATIMA VOICE
      =================================================== */}

      <div className="satima-voice-card">

        <span className="satima-voice-number">
          01
        </span>

        <div className="satima-voice-content">

          <span className="satima-voice-label">
            OUR APPROACH
          </span>

          <h3>
            We speak as a consultant,
            strategist, and partner.
          </h3>

          <p>
            Our role is not simply to execute digital activities.
            We help businesses understand what they need, why they
            need it, and how each activity contributes to their
            broader growth objectives.
          </p>


          {/* COMMUNICATION PRINCIPLES */}

          <div className="satima-voice-principles">

            <span>Confident</span>
            <span>Clear</span>
            <span>Calm</span>
            <span>Educative</span>

          </div>


          <div className="satima-voice-boundary">

            <span className="satima-boundary-line"></span>

            <p>
              Never desperate. Never hype-driven.
              Never misleading.
            </p>

          </div>

        </div>

      </div>



      {/* ===================================================
          RIGHT — IDEAL CLIENT
      =================================================== */}

      <div className="satima-client-card">

        <span className="satima-client-number">
          02
        </span>

        <div className="satima-client-content">

          <span className="satima-client-label-small">
            IDEAL CLIENT
          </span>

          <h3>
            Businesses We Work Best With
          </h3>

          <p className="satima-client-description">
            We work best with businesses that value structure,
            professionalism, and sustainable digital growth.
          </p>


          {/* CLIENT COLUMNS */}

          <div className="satima-client-columns">


            {/* WE WORK WITH */}

            <div className="satima-client-column satima-client-positive">

              <h4>
                We work with
              </h4>

              <ul>

                <li>
                  <span>✓</span>
                  SMEs & professionals in Kenya
                </li>

                <li>
                  <span>✓</span>
                  Businesses tired of random marketing
                </li>

                <li>
                  <span>✓</span>
                  Founders who value structure and results
                </li>

                <li>
                  <span>✓</span>
                  Clients ready to invest in growth
                </li>

              </ul>

            </div>



            {/* WE DON'T CHASE */}

            <div className="satima-client-column satima-client-negative">

              <h4>
                We don't chase
              </h4>

              <ul>

                <li>
                  <span>×</span>
                  Cheap-only engagements
                </li>

                <li>
                  <span>×</span>
                  "Just post for me" requests
                </li>

                <li>
                  <span>×</span>
                  Unrealistic expectations
                </li>

              </ul>

            </div>


          </div>

        </div>

      </div>


    </div>



    {/* =====================================================
        BOTTOM STATEMENT
    ===================================================== */}

    <div className="satima-client-bottom">

      <span className="satima-client-bottom-line"></span>

      <p>
        The right partnership starts with shared expectations,
        clear communication, and a commitment to meaningful growth.
      </p>

    </div>


  </div>

</section>


  {/* =========================================================
    DIGITAL GROWTH SERVICES
========================================================= */}

<section id="services" className="st-services-section">

  <div className="st-services-container">

    {/* HEADER */}

    <div className="st-services-header">

      <span className="st-services-label">
        WHAT WE DO
      </span>

      <h2>
        Digital Solutions
        <br />
        <span>Built With Purpose.</span>
      </h2>

      <p>
        From websites to digital marketing, we create practical
        solutions designed around your business goals and customers.
      </p>

    </div>


    {/* SERVICES */}

    <div
      className="st-services-grid"
      ref={servicesSliderRef}
    >

      {services.map((service, index) => (

        <article
          className="st-service-card"
          key={index}
        >

          <div className="st-service-top">

            <span className="st-service-number">
              {String(index + 1).padStart(2, "0")}
            </span>

            <div className="st-service-icon">
              {service.icon}
            </div>

          </div>


          <div className="st-service-content">

            <h3>
              {service.name}
            </h3>

            <p>
              {service.description}
            </p>

          </div>


          <a
            href={service.link}
            className="st-service-link"
          >
            <span>Discover More</span>
            <span className="st-service-arrow">→</span>
          </a>

        </article>

      ))}

    </div>


    {/* MOBILE / SLIDER NAVIGATION */}

    <div className="st-services-navigation">

      <button
        onClick={() => scrollServices("prev")}
        aria-label="Previous service"
      >
        ←
      </button>

      <span>
        EXPLORE SERVICES
      </span>

      <button
        onClick={() => scrollServices("next")}
        aria-label="Next service"
      >
        →
      </button>

    </div>

  </div>

</section>


{/* =========================================================
    THE SATIMA WAY — FAQ SECTION
========================================================= */}

<section className="satima-way-faq-section">


  <div className="satima-way-faq-header">

    <span className="satima-way-faq-label">
      FREQUENTLY ASKED QUESTIONS
    </span>


    <h2>
      Understanding
      <br />
      The Satima Way
    </h2>


    <p>
      Learn more about how we approach digital growth, work with
      businesses, and build structured strategies designed around
      meaningful business outcomes.
    </p>

  </div>



  <div className="satima-way-faq-container">


    {/* =====================================================
        FAQ 1 — SATIMA WAY
    ===================================================== */}

    <div className="satima-way-faq-item">

      <details>

        <summary>

          What is The Satima Way?

          <FaChevronDown />

        </summary>


        <p>
          The Satima Way is our structured approach to digital growth.
          Instead of treating websites, marketing, social media, SEO,
          and technology as disconnected activities, we look at how
          these elements can work together around a clear business
          objective.

          <br /><br />

          Our approach focuses on strategy, the right digital systems,
          consistent execution, and continuous improvement.

        </p>


      </details>

    </div>



    {/* =====================================================
        FAQ 2 — STRATEGY FIRST
    ===================================================== */}

    <div className="satima-way-faq-item">

      <details>

        <summary>

          Why does Satima take a strategy-first approach?

          <FaChevronDown />

        </summary>


        <p>
          We believe digital activities are more effective when they
          have a clear purpose behind them.

          <br /><br />

          Before recommending a solution, we consider the business,
          target audience, current digital presence, objectives, and
          available opportunities. This helps us avoid simply doing
          things online without understanding what they are expected
          to achieve.

        </p>


      </details>

    </div>



    {/* =====================================================
        FAQ 3 — BUSINESS OUTCOMES
    ===================================================== */}

    <div className="satima-way-faq-item">

      <details>

        <summary>

          How does Satima measure digital growth?

          <FaChevronDown />

        </summary>


        <p>
          We look beyond activity and vanity metrics.

          <br /><br />

          Depending on the business and strategy, we may focus on
          indicators such as qualified enquiries, leads, website
          engagement, conversions, customer actions, search visibility,
          and other metrics connected to the actual business objective.

          <br /><br />

          The goal is to understand whether digital activity is
          contributing to meaningful business progress.

        </p>


      </details>

    </div>



    {/* =====================================================
        FAQ 4 — DIGITAL SYSTEMS
    ===================================================== */}

    <div className="satima-way-faq-item">

      <details>

        <summary>

          Why does Satima focus on digital systems instead of isolated activities?

          <FaChevronDown />

        </summary>


        <p>
          Businesses rarely grow from one digital activity working in
          isolation.

          <br /><br />

          A website may generate enquiries, SEO can help people discover
          the business, social media can build trust, and advertising
          can create targeted opportunities. These elements can become
          more valuable when they support one another.

          <br /><br />

          We therefore focus on creating a connected digital presence
          rather than simply completing individual tasks.

        </p>


      </details>

    </div>



    {/* =====================================================
        FAQ 5 — IDEAL CLIENT
    ===================================================== */}

    <div className="satima-way-faq-item">

      <details>

        <summary>

          What type of businesses does Satima work best with?

          <FaChevronDown />

        </summary>


        <p>
          We work best with SMEs, professionals, founders, and growing
          businesses that want to build a stronger digital presence
          with structure and direction.

          <br /><br />

          Our ideal clients value clear communication, professional
          execution, realistic expectations, and measurable progress.

          <br /><br />

          We are not focused on simply delivering the cheapest possible
          digital service. We focus on building solutions that make
          sense for the business.

        </p>


      </details>

    </div>



    {/* =====================================================
        FAQ 6 — PARTNERSHIP
    ===================================================== */}

    <div className="satima-way-faq-item">

      <details>

        <summary>

          What can I expect when working with Satima?

          <FaChevronDown />

        </summary>


        <p>
          You can expect a structured and professional working
          relationship built around clear communication and agreed
          objectives.

          <br /><br />

          We aim to understand your business before recommending
          solutions, communicate clearly throughout the engagement,
          and focus on work that contributes to your broader digital
          growth objectives.

          <br /><br />

          The goal is not simply to complete a project. It is to build
          digital foundations that can continue supporting your
          business as it grows.

        </p>


      </details>

    </div>


  </div>


</section>



{/* =====================================
    FINAL TAGLINE CTA SECTION
===================================== */}

<section className="final-cta-section">


  <div className="final-cta-content">


    <span className="final-cta-label">
      DIGITAL GROWTH PARTNER
    </span>




    <h2>

      Turning Your Online Presence
      <br />
      Into Paying Clients

    </h2>




    <p>

      Satima Technova Solutions does not just complete digital tasks.
      We create clarity, strategy, and growth-focused solutions that help
      businesses attract customers, build credibility, and achieve measurable
      results online.

    </p>




    <div className="final-cta-benefits">


      <span>
        Strategic Digital Solutions
      </span>


      <span>
        More Online Visibility
      </span>


      <span>
        Customer-Focused Strategies
      </span>


      <span>
        Growth-Driven Approach
      </span>


    </div>





    <a
      href="/contact"
      className="final-cta-btn"
    >

      Start A Strategy Conversation →

    </a>





    <p className="final-cta-note">

      Free consultation • Transparent solutions • Helping Kenyan businesses grow online

    </p>



  </div>


</section>

      </main>
    </>
  );
};

export default TheSatimaWay;